<template>
  <Modal :active="active" @close="cancel">
    <div class="text-center p-4">
      <h2 class="text-2xl text-white-1">{{ $t('setup.confirm.title') }}</h2>

      <p class="font-light mt-3">{{ $t('setup.confirm.message') }}</p>

      <div class="mt-10 flex justify-center">
        <Button :label="$t('setup.confirm.cancel')" @click="cancel" />

        <Button class="ml-4" color="btn-primary-outline" :label="$t('setup.confirm.confirm')" @click="confirm" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import Button from '@/components/Button.vue';

export default {
  name: 'SetupModalWithoutCamera',
  components: { Modal, Button },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>
